var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpgradeSubs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 1.33301C7.89398 1.33301 1.33398 7.89301 1.33398 15.9997C1.33398 24.1063 7.89398 30.6663 16.0007 30.6663C24.1073 30.6663 30.6673 24.1063 30.6673 15.9997C30.6673 7.89301 24.1073 1.33301 16.0007 1.33301ZM21.7207 16.9463L17.334 12.5463V23.9997H14.6673V12.5463L10.2807 16.933L8.40065 15.053L16.0007 7.45301L23.614 15.0663L21.7207 16.9463Z",
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeSubs);
export default __webpack_public_path__ + "static/media/upgrade-subs.6c591b82e1b56ca8dd96ac3ba7686098.svg";
export { ForwardRef as ReactComponent };